<template>
  <button
    :class="`${type}-button`"
    @click="$emit('click')"
    :disabled="disabled"
  >
    <i class="material-icons md-18">{{ icon || button[type].icon }}</i
    >{{ text || button[type].text }}
  </button>
</template>
<script>
export default {
  props: {
    type: String,
    text: String,
    disabled: Boolean,
    icon: String,
  },
  data() {
    return {
      button: {
        save: {
          icon: "save",
          text: "Save",
        },
        add: {
          icon: "add",
          text: "Add",
        },
        cancel: {
          icon: "clear",
          text: "Cancel",
        },
        update: {
          icon: "save",
          text: "Save & Update",
        },
        new: {
          icon: "save",
          text: "Save as New",
        },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.button {
  outline: none !important;
  background: var(--color-primary-light);
  padding: 10px;
  border: 0;
  border-radius: 5px;
  padding: 10px 15px;
  color: var(--color-primary);
  font-weight: bold;
  transition: 0.3s all ease-in-out;
  display: flex;
  flex-direction: row;
  align-items: center;

  i {
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
    background: var(--color-primary);
    color: var(--color-secondary);
  }

  &:active {
    transform: scale(0.9);
  }
}

.save-button,
.new-button,
.update-button {
  @extend .button;
  background: var(--color-primary);
  color: var(--color-secondary);

  &:hover {
    background: var(--color-primary-dark);
    color: var(--color-secondary);
  }

  &:disabled {
    background: var(--font-color-unselected);
    color: var(--font-color);

    &:hover {
      background: var(--font-color-unselected);
      color: var(--font-color);
      cursor: not-allowed;
    }
  }
}

.cancel-button {
  @extend .button;
  background: var(--font-color-unselected);
  color: var(--font-color);
  margin-right: 10px;

  &:hover {
    background: var(--border-color);
    color: var(--font-color);
  }

  &.disabled {
    background: var(--font-color-unselected);
    color: var(--font-color);

    &:hover {
      background: var(--font-color-unselected);
      color: var(--font-color);
      cursor: not-allowed;
    }
  }
}
</style>
